import React, { Component, useState } from "react"
import { NavLink } from "react-router-dom"
import classnames from "classnames"
import logo from './../../../../assets/img/logo/Claro-Logo.png'
import logo_innovate from './../../../../assets/img/logo/Claro-Logo.png'
import { ModalRequestToken } from "../../../../views/components/modal/ModalRequestToken"

const SidebarHeader = (props) => {
  let { menuShadow } = props
  const {use_token} = JSON.parse(sessionStorage.getItem('user'))
  const [showModalRequestToken, setShowModalRequestToken] = useState(false)

  return (
    <div className="navbar-header text-center" style={{ height: '100px' }}>
      <ul className="nav navbar-nav flex-row">
        <li className="nav-item mr-auto">
          <NavLink to="/home" className="navbar-brand">
            <img src={logo_innovate} alt={logo} style={{ width: '110px', marginLeft: '60px', marginTop: '-20px' }} />
          </NavLink>
        </li>
      </ul>
      {
        use_token != undefined && use_token === true &&
          <div className="badge badge-success badge-glow" title="Solicitud de TOKEN" style={{cursor:'pointer'}} onClick={() => { setShowModalRequestToken(!showModalRequestToken) }}>Solicitar TOKEN</div>
      }
      <div className={classnames("shadow-bottom", { "d-none": menuShadow === false })} />
      { showModalRequestToken && <ModalRequestToken showModal={showModalRequestToken} setShowModal={setShowModalRequestToken}  />}
    </div>
  )
}

export default SidebarHeader
